import './video.scss';

document.addEventListener('DOMContentLoaded', function() {
    // Support multiple video blocks on a page
    const videoHolders = document.querySelectorAll('.js-videoHolder');

    if (!videoHolders.length) {
        return;
    }

    videoHolders.forEach(function(holder) {
        const videoWrapper = holder.querySelector('.js-video');
        const videoImage   = holder.querySelector('.js-videoImage');
        const videoPlay    = holder.querySelector('.js-videoPlay');

        if (!videoWrapper || !videoPlay) {
            return;
        }

        videoPlay.addEventListener('click', function() {
            // Hide overlay elements if present
            if (videoImage) {
                videoImage.classList.add('-hidden');
            }
            videoPlay.classList.add('-hidden');
            videoWrapper.classList.add('-active');

            // Try iframe (YouTube/Vimeo/etc.)
            const iframe = videoWrapper.querySelector('iframe');

            if (iframe) {
                const originalSrc = iframe.getAttribute('src') || '';

                if (originalSrc && originalSrc.indexOf('autoplay=1') === -1) {
                    const separator = originalSrc.indexOf('?') === -1 ? '?' : '&';
                    const newSrc = originalSrc + separator + 'autoplay=1';

                    // Extra safety: only set if we actually built a string
                    if (newSrc) {
                        iframe.setAttribute('src', newSrc);
                    }
                }

                return; // Don’t try HTML5 <video> if we already handled iframe
            }

            // Try HTML5 <video>
            const html5Video = videoWrapper.querySelector('video');

            if (html5Video) {
                html5Video.muted = true;
                // Ignore play errors (e.g., autoplay restrictions)
                Promise.resolve(html5Video.play()).catch(function() {});
            }
        });
    });
});
